//@flow
import React from 'react';
import {Container} from 'flux/utils';
import Shell from '../../Shell/components/Shell.react';
import NotFound from '../../ProductDetails/components/NotFound.react';
import CustomerStore from '../../Stores/Customer/customer';
import ProductsStore from '../../Stores/Products/products';
import CategoriesStore from '../../Stores/MemberCategories/categories';
import QuoteStore from '../../Stores/Quote';
import Category from './category.react';
import FiltersStore from '../../Stores/Filters/filtersStore';
import StockStore from '../../Stores/Stock/stock';
import MembershipStore from '../../Stores/Membership/membershipStore';
import StockRemindersStore from '../../Stores/StockReminders/stockReminders';
import {OFFICE_BLACKLIST} from '../../Stores/MemberCategories/categoriesCollection';

import type { List } from 'immutable';
import type { ContextRouter } from 'react-router';
import type MembershipModel from '../../Stores/Membership/membershipModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type { Filter, FilterCategories } from '../../Stores/Filters/filtersStoreClass';

type State = {
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  quoteTotals:QuoteTotalsModel,
  products:ProductsCollection,
  membership:MembershipModel,
  isMember:boolean,
  userCountry:string,
  membershipPlan:MembershipPlanModel,
  inUS:boolean,
  categories:CategoriesCollection,
  categoryModel:?CategoryModel,
  filters:Filter[],
  allFilters:FilterCategories,
  stock:StockCollection,
  customer:CustomerModel,
  stockReminders:List<string>,
  inFreeBox:boolean,
};

type Props = ContextRouter;

class CategoryApp extends React.Component<Props, State> {
  static getStores() {
    return [
      ProductsStore,
      CategoriesStore,
      CustomerStore,
      FiltersStore,
      StockStore,
      QuoteStore,
      MembershipStore,
      StockRemindersStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    const isOffice = props.location.pathname.startsWith('/office/catalog');
    const quote = QuoteStore.getQuote();
    const quoteItems = QuoteStore.getQuoteItems(quote.getId());
    const products = ProductsStore.getProducts();
    const quoteTotals = QuoteStore.getQuoteTotals(quote.getId(), {
      products,
      quoteItems,
    });
    const membership = MembershipStore.getMembership();
    const isMember = membership && membership.isReturningMember();
    const userCountry = CustomerStore.getCurrentCountryCode(quote);
    const newMemberPlanCode = quote.getNewMembershipPlanCode();
    const membershipPlan = MembershipStore.getMembershipPlan(newMemberPlanCode);
    const customer =  CustomerStore.getCustomer();

    const categories = CategoriesStore.getCategories();
    // NOTE: this is kind of a hack to blacklist certain
    // categories for when user is viewing catalog app
    // in office context.
    if (isOffice) {
      categories.__removeItems(OFFICE_BLACKLIST);
    }
    const categoryModel = categories.findByUrlKey(props.params.urlKey || '');

    return {
      quote,
      quoteItems,
      quoteTotals,
      products,
      membership,
      isMember,
      userCountry,
      membershipPlan,
      inUS: CustomerStore.inUS(quote),
      categories,
      categoryModel,
      filters: FiltersStore.getSelectedFilters(),
      allFilters: FiltersStore.getFilterCategories(),
      stock: StockStore.getStock(),
      customer,
      stockReminders: StockRemindersStore.getStockReminders(),
      inFreeBox: !!props.location.query['nbox_free_box_sku'],
    };
  }

  _getPageMeta() {
    const meta = {
      title: 'Category Detail | NatureBox',
      metaDescription: '',
    };
    const category = this.state.categoryModel;
    if (category) {
      // Use meta title if provided; otherwise use cat name
      meta.title = category.getMetaTitle() || category.getName();
      meta.metaDescription = category.getMetaDescription();
    }
    return meta;
  }

  _renderCategory() {
    const category = this.state.categoryModel;
    if (!this.state.products.isLoaded()) return null;
    if (!category) return <NotFound />;
    const isOffice = this.props.location.pathname.startsWith('/office/catalog');

    return (
      <Category
        {...this.state}
        category={category}
        location={this.props.location}
        isOffice={isOffice}
      />
    );
  }

  render() {
    const meta = this._getPageMeta();
    return (
      <Shell
        helloBar={true}
        pageTitle={meta.title}
        metaDescription={meta.metaDescription}
      >
        {this._renderCategory()}
      </Shell>
    );
  }
}

export default Container.create(CategoryApp, { withProps: true });
